import { store } from '@/store'
import { SetGetAuthInfo } from '@/util/auth'
import Vue from 'vue'
import Router from 'vue-router'
import {
  getDeviceInfo,
  JsonToParams,
  QueryToJSON,
  gethttpurl
} from '../util/tools'
import { InsuRoutes } from './module/Insu'
import { UserCenterRoutes } from './module/userCenter'
import { UserPolicyRoutes } from './module/userPolicy'
import { PosterRoutes } from './module/PosterDeal'
import { PayRoutes } from './module/pay'
import { orderIns } from './module/orderIns'
import { surrender } from './module/surrender'

const DeviceInfo = getDeviceInfo()

const CommonRoutes = [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/Auth'),
    meta: {
      title: ''
    }
  },
  {
    path: '/insured-query',
    name: 'InsuredQuery',
    component: () => import('@/views/UserPolicy/InsuredQuery'),
    meta: {
      title: '参保查询',
      needToken: false
    }
  },
  {
    path: '/claim',
    name: 'claim',
    component: () => import('@/views/claim'),
    meta: {
      title: '',
      needToken: true
    }
  },
  {
    path: '/myClaim',
    name: 'myClaim',
    component: () => import('@/views/myClaim'),
    meta: {
      title: '',
      needToken: true
    }
  },
  {
    path: '/insured-policy-detail',
    name: 'InsuredPolicyDetail',
    component: () => import('@/views/UserPolicy/InsuredPolicyDetail'),
    meta: {
      title: '参保查询结果',
      needToken: false
    }
  },
  {
    path: '/404',
    name: 'Page404',
    component: () => import('@/views/Page404/Page404'),
    meta: {
      title: '404'
    }
  },
  {
    path: '/noScan',
    name: 'NoScan',
    component: () => import('@/views/Page404/NoScan'),
    meta: {
      title: '暂未开通'
    }
  },
  {
    path: '/end',
    name: 'PageEnd',
    component: () => import('@/views/Page404/PageEnd'),
    meta: {
      title: '投保通道已关闭'
    }
  },
  {
    path: '/customer-service',
    name: 'CustomerService',
    component: () => import('@/views/customerService/index'),
    meta: {
      title: '客服咨询'
    }
  }
]
const weixinRoutes =
  process.env.NODE_ENV === 'development' || DeviceInfo.env === 'wechat'
    ? [...UserCenterRoutes, ...UserPolicyRoutes]
    : []

Vue.use(Router)

const routerInfo = new Router({
  routes: [
    // 通用路由
    ...CommonRoutes,
    // 保险相关路由
    ...InsuRoutes,
    // 微信环境路由, 用户中心、保单中心
    ...weixinRoutes,
    //  代理人工具
    ...PosterRoutes,
    ...PayRoutes,
    // 预约投保
    ...orderIns,
    ...surrender,
    {
      path: '*',
      redirect: '/404'
    }
  ],
  scrollBehavior: function(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
// 路由守卫
// 前置钩子
routerInfo.beforeEach(function(to, from, next) {
  // 百度统计
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  const bo = checkAuth(to)
  if (bo) {
    next()
    if (to.redirectedFrom.indexOf('/area-insu-buy-detail&') > -1) {
      let fromSourceCode = gethttpurl('fromSourceCode')
      let baosicode = gethttpurl('baosicode')
      let reUrl =
        location.href.split('?')[0] +
        `?fromSourceCode=${fromSourceCode}` +
        `&baosicode=${baosicode}` +
        `&${
          location.href.split('/area-insu-buy-detail&')[1]
        }#/area-insu-buy-detail`
      console.log(reUrl)
      location.href = reUrl
    } else {
      next()
    }
  } else {
    if (
      to.meta.needToken &&
      !store.state.userInfo.token &&
      store.state.userInfo.openId
    ) {
      // 页面需要token，经过授权有openId，但没有token，直接跳转个人中心
      next({ path: '/user-center' })
    } else {
      toAuthHtml(to, next)
    }
  }
})
// 后置钩子
routerInfo.afterEach(function(to) {
  console.log(to)
  const title = to.meta && to.meta.title ? to.meta.title : ''
  if (to.name === 'WholeCountry') {
    //const title = to.meta && to.meta.title ? to.meta.title : ''
    // document.title = title
    document.title = '湖南爱民保'
  } else if (to.name === 'country') {
    //const title = to.meta && to.meta.title ? to.meta.title : ''
    // document.title = title
    document.title = '湖南爱民保' + title
  } else {
    document.title = '湖南爱民保' + title
  }

  switchViewPort(to)
  // 微信环境下，添加？
  if (DeviceInfo.env === 'wechat') {
    replaceHref()
  }
})
// 页面加载js错误处理
routerInfo.onError(error => {
  const pattern = /Loading chunk .* failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    location.reload()
  }
})

function switchViewPort(to) {
  const meta = document.getElementById('metaViewport')
  if (to.name === 'pdf') {
    meta.setAttribute(
      'content',
      'width=device-width,initial-scale=1.0, minimum-scale=1.0,viewport-fit=cover'
    )
  } else {
    meta.setAttribute(
      'content',
      'width=device-width,initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no,viewport-fit=cover'
    )
  }
}

function checkAuth(to) {
  if (DeviceInfo.env === 'wechat') {
    // if (gethttpurl('fromSourceCode') === 'yxhb00000304') {
    //   return true
    // }
    const cookieUser = SetGetAuthInfo.getInfo()
    let whiltList = ['InsuredQuery', 'Auth', 'Page404', 'PageEnd']
    if (whiltList.includes(to.name)) {
      return true
    } else {
      if (cookieUser.openId && !store.state.userInfo.openId) {
        store.commit('SET_USER_INFO', cookieUser)
      }
      return !!store.state.userInfo.openId
    }
  }
  return true
}

// 去auth.html 中转授权
function toAuthHtml(to, next) {
  let obj = QueryToJSON()
  obj = Object.assign(obj, {
    fromPath: encodeURIComponent(to.fullPath)
  })
  location.href = 'auth.html?' + JsonToParams(obj)
  next(false)
}

// 支持微信支付处理，页面后面加?
function replaceHref() {
  const href = location.href
  if (!/\.html\?/.test(href)) {
    const link = href.replace(/\.html/, '.html?')
    history.replaceState('', '', link)
  }
}

if (process.env.NODE_ENV === 'development') {
  const cookieUser = SetGetAuthInfo.getInfo()
  store.commit('SET_USER_INFO', cookieUser)
}

export const router = routerInfo
